import { ca } from '@cian/analytics';
import { EPageBlock } from '../../../types/analytics';

type TAction = 'show_sopr' | 'Click';

const trackCategoriesEvent = (action: TAction) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action,
    label: 'Block',
    page: {
      extra: {
        block: EPageBlock.Categories,
      },
    },
  });
};

export const trackCategoriesShow = () => trackCategoriesEvent('show_sopr');
export const trackCategoryClick = () => trackCategoriesEvent('Click');
